import {
    apiRequest,
    list, 
    inactive,
    formLegalisir,
    formBPJS,
    formTASPEN,
    formKP4,
    approve
} from "../../../../../services/adapters/kepegawaian/pengajuanOnlineService"

class IndexRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", list, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", inactive, {
            body: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", approve, {
            body: query
        }, true)
    }


    fetchFormLegalisir = async (query, cancelToken) => {
        return await apiRequest("get", formLegalisir, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchFormBPJS = async (query, cancelToken) => {
        return await apiRequest("get", formBPJS, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchFormTASPEN = async (query, cancelToken) => {
        return await apiRequest("get", formTASPEN, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchFormKP4 = async (query, cancelToken) => {
        return await apiRequest("get", formKP4, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default IndexRepository